import { Calendar, Clock, Phone, Video, Users, X, type LucideIcon } from "lucide-react";
import { MEETING_STATUS_VALUES } from "@/lib/constants/meeting-statuses";
import type { Meeting_Status } from "@/src/gql/graphql";

export const MEETING_TYPE_OPTIONS = [
  { value: "call", label: "Phone Call", icon: Phone },
  { value: "video_call", label: "Video Call", icon: Video },
  { value: "in_person", label: "In Person", icon: Users },
  { value: "other", label: "Other", icon: Calendar },
] as const;

const MEETING_STATUS_META: Record<
  Meeting_Status,
  { label: string; color: string; icon: LucideIcon }
> = {
  scheduled: {
    label: "Scheduled",
    color: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200",
    icon: Calendar,
  },
  completed: {
    label: "Completed",
    color: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200",
    icon: Calendar,
  },
  cancelled: {
    label: "Cancelled",
    color: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200",
    icon: X,
  },
  rescheduled: {
    label: "Rescheduled",
    color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200",
    icon: Clock,
  },
};

/** UI options — values from `MEETING_STATUS_VALUES`. */
export const MEETING_STATUS_OPTIONS = MEETING_STATUS_VALUES.map((value) => ({
  value,
  label: MEETING_STATUS_META[value].label,
  color: MEETING_STATUS_META[value].color,
  icon: MEETING_STATUS_META[value].icon,
}));
